import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../../Components/Alert";
import {
  Campus_Add_By_University_Model,
  Courses_Form_Model,
  Courses_Form_Model_Checker,
} from "../../Models/CoursesModel";
import {
  ADD_CAMPUS_BY_COURSE,
  ADD_CAMPUS_BY_COURSE_RESET,
  CAMPUS_DELETE_ALL,
  COURSES_CREATE_LIST,
  COURSES_CREATE_LIST_FORM_RESET,
  COURSES_UPDATE,
  COURSES_UPDATE_RESET_FORM,
  COURSE_SINGLE_DATA_RESET,
} from "../../Actions/courseAction";
import {
  CAMPUS_LISTS,
  LIST_CAMPUS_BY_COURSE_ID_RESET,
} from "../../Actions/campusAction";
import ReactQuill from "react-quill";
import { STUDENT_LEVEL_LISTS } from "../../Actions/courseOfferedAction";
import IeltsScore from "../../Components/IeltsScoreSelector";
import UniversitySelector from "../../Components/UniversitySelector";
import CourseTypeSelector from "../../Components/CourseTypeSelector";
import MultiSelector from "../../Components/MultiSelector";

export default function CreateCourse({
  handleFormClose,
  FormOpener,
  EditFormOpener,
  handleEditorForm,
  Courses_Lists_Get_Req,
  CourseID,
}) {
  const [CourseForm, setCourseForm] = useState(Courses_Form_Model);
  const [CourseForm2, setCourseForm2] = useState(Courses_Form_Model);
  const [selectCampus, setSelectCampus] = useState([]);
  const [CampusDropDown, setCampusDropDown] = useState(false);
  const [CourseclassNameicEditorInput, setCourseclassNameicEditorInput] =
    useState({
      Entry_Requirement: "",
    });
  const [CourseclassNameicEditorInput2, setCourseclassNameicEditorInput2] =
    useState({
      Entry_Requirement: "",
    });
  const [Alert, setAlert] = useState([]);
  const [Campuses, setCampuses] = useState([]);
  const [Campus_Add_Checker, setCampus_Add_Checker] = useState([]);
  const [PreSeSelectedCampuses, setPreSeSelectedCampuses] = useState([]);
  const multiselectRefTracker = useRef();

  const { Course_Create_Loading, Course_Create_Success, Course_Create_Error } =
    useSelector((state) => state.COURSES_CREATE_REDUCER);

  const { Course_Update_Loading, Course_Update_Success, Course_Update_Error } =
    useSelector((state) => state.COURSE_LIST_UPDATE_REDUCER);

  const { Course_Single_Data, Course_Single_Loading } = useSelector(
    (state) => state.COURSE_SINGLE_DATA_REDUCER
  );

  const { Campus_Added_Loading, Campus_Added_Success } = useSelector(
    (state) => state.CAMPUS_ADD_BY_COURSES_REDUCER
  );
  const {
    Campus_list_By_Course,
    Campus_list_By_Course_Loading,
    Campus_list_By_Course_Error,
  } = useSelector((state) => state.CAMPUS_LIST_BY_COURSE_REDUCER);

  const {
    Campus_DeleteAll_Loading,
    Campus_DeleteAll_Success,
    Campus_DeleteAll_Error,
  } = useSelector((state) => state.CAMPUS_DELETE_BY_COURSE);

  const dispatch = useDispatch();

  const handleFormChange = (e) => {
    if (EditFormOpener) {
      setCourseForm2({
        ...CourseForm2,
        [e.target.name]: e.target.value,
      });
    } else {
      setCourseForm({
        ...CourseForm,
        [e.target.name]: e.target.value,
      });
    }
    if (e.target.name === "University_Id") {
      if (e.target.value === "") {
        dispatch(CAMPUS_LISTS(-1));
      } else {
        dispatch(CAMPUS_LISTS(e.target.value));
      }
    }
    setAlert([]);
  };

  const handleMultiSelectRemove = (e) => {
    setSelectCampus(e);
  };

  const handleFormCancel = () => {
    handleFormClose();
    dispatch(COURSES_CREATE_LIST_FORM_RESET());
    setAlert([]);
    handleMultiSelectRemove([]);
    setCourseForm(Courses_Form_Model);
    setCourseclassNameicEditorInput({
      Entry_Requirement: "",
    });
    setSelectCampus("");
    setCampusDropDown(false);
    setCampuses([]);
    multiselectRefTracker.current.resetSelectedValues();
    setCampus_Add_Checker([]);
  };

  const handleEditCancel = () => {
    setCourseForm(Courses_Form_Model);
    setCourseclassNameicEditorInput({
      Entry_Requirement: "",
    });
    handleEditorForm();
    setAlert([]);
    dispatch(COURSE_SINGLE_DATA_RESET());
    dispatch(COURSES_UPDATE_RESET_FORM());
    dispatch(LIST_CAMPUS_BY_COURSE_ID_RESET());
    setSelectCampus("");
    setCampuses([]);
    setCampusDropDown(false);
    multiselectRefTracker.current.resetSelectedValues();
    setCampus_Add_Checker([]);
  };

  /*  Course Create Error and Success handle start  */
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = Courses_Form_Model_Checker(CourseForm);
    if (FormCheck[0] === "success") {
      for (var i = 0; i < selectCampus.length; i++) {
        Campuses.push({
          ...Campus_Add_By_University_Model,
          University_Id: CourseForm.University_Id,
          Campus_Id: selectCampus[i].Campus_Id,
        });
      }
    }

    if (FormCheck[0] === "success" && Campuses.length !== 0) {
      dispatch(
        COURSES_CREATE_LIST({ ...CourseForm, ...CourseclassNameicEditorInput })
      );
    } else if (FormCheck[0] !== "success") {
      setAlert([FormCheck]);
    } else if (Campuses.length === 0) {
      setAlert(["Campus Name is Mandatory!"]);
    }
  };

  useEffect(() => {
    if (Course_Create_Error) {
      setAlert([Course_Create_Error]);
    }
    if (Course_Create_Success) {
      for (let i = 0; i < Campuses.length; i++) {
        const dispatchReq = async (i) => {
          Campuses[i].Course_Id = Course_Create_Success;
          await dispatch(ADD_CAMPUS_BY_COURSE(Campuses[i]));
          setCampus_Add_Checker((prev) => [...prev, Campus_Added_Success]);
        };
        dispatchReq(i);
      }
    }
  }, [Course_Create_Error, Course_Create_Success, dispatch]);

  /*  Course Edit Req Error and Success handle  */

  const handleEditFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = Courses_Form_Model_Checker(CourseForm2);
    if (FormCheck[0] === "success") {
      for (let i = 0; i < selectCampus?.length; i++) {
        Campuses.push({
          ...Campus_Add_By_University_Model,
          University_Id: CourseForm2.University_Id,
          Campus_Id: selectCampus[i].Campus_Id,
        });
      }
    }

    if (!CampusDropDown && FormCheck[0] === "success") {
      if (Campuses.length === 0 && PreSeSelectedCampuses?.length !== 0) {
        for (let i = 0; i < PreSeSelectedCampuses?.length; i++) {
          Campuses.push({
            ...Campus_Add_By_University_Model,
            University_Id: CourseForm2.University_Id,
            Campus_Id: PreSeSelectedCampuses[i].Campus_Id,
          });
        }
      }
    }

    //-------

    if (FormCheck[0] === "success" && Campuses.length !== 0) {
      dispatch(
        COURSES_UPDATE(CourseID, {
          ...CourseForm2,
          ...CourseclassNameicEditorInput2,
        })
      );
      dispatch(CAMPUS_DELETE_ALL(CourseID));
    } else if (FormCheck[0] !== "success") {
      setAlert([FormCheck]);
    } else if (Campuses.length === 0) {
      setAlert(["Campus Name is Mandatory!"]);
    }
  };

  // -------

  useEffect(() => {
    if (Course_Update_Error) {
      setAlert([Course_Update_Error]);
    }
    if (
      Campus_list_By_Course_Error !== "Error-No Record Exist!" &&
      Campus_DeleteAll_Error
    ) {
      // setAlert([Campus_DeleteAll_Error]);
    }
  }, [
    Campus_DeleteAll_Error,
    Course_Update_Error,
    Campus_list_By_Course_Error,
  ]);

  useEffect(() => {
    if (
      Campus_Add_Checker.length === Campuses.length &&
      Campus_Added_Success &&
      Course_Create_Success
    ) {
      dispatch(ADD_CAMPUS_BY_COURSE_RESET());
      setAlert(["Courses Added Successfully!"]);
      setTimeout(() => {
        handleFormCancel();
        Courses_Lists_Get_Req();
      }, 2000);
    }

    if (
      Campus_Add_Checker.length === Campuses.length &&
      Course_Update_Success &&
      Campus_Added_Success
    ) {
      setAlert([Course_Update_Success]);
      dispatch(ADD_CAMPUS_BY_COURSE_RESET());
      setTimeout(() => {
        handleEditCancel();
        Courses_Lists_Get_Req();
      }, 1200);
    }
  }, [Campus_Added_Success, Campus_Add_Checker, dispatch]);
  /*  Course Create Error and Success handle End */

  // ------campus

  useEffect(() => {
    if (
      Campus_list_By_Course_Error === "Error - No Record Exist!" ||
      Campus_DeleteAll_Success
    ) {
      if (Course_Update_Success) {
        for (let i = 0; i < Campuses.length; i++) {
          Campuses[i].Course_Id = CourseID;
          dispatch(ADD_CAMPUS_BY_COURSE(Campuses[i]));
          setCampus_Add_Checker((prev) => [...prev, Campus_Added_Success]);
        }
      }
    }
  }, [Campus_DeleteAll_Success, Course_Update_Success, dispatch]);
  //  ----

  useEffect(() => {
    if (EditFormOpener) {
    } else {
      dispatch(CAMPUS_LISTS(-1));
    }
  }, [FormOpener, EditFormOpener, dispatch]);
  // ----

  useEffect(() => {
    if (Course_Single_Data && EditFormOpener) {
      for (let key in Course_Single_Data[0]) {
        if (Course_Single_Data[0][key] === null) {
          Course_Single_Data[0][key] = "";
        }
      }
      setCourseForm2(Course_Single_Data[0]);
      setCourseclassNameicEditorInput2({
        Entry_Requirement: Course_Single_Data[0].Entry_Requirement,
      });
    } else {
      // setCourseForm(Courses_Form_Model);
    }
    dispatch(STUDENT_LEVEL_LISTS());
  }, [EditFormOpener, Course_Single_Data, dispatch]);

  // -----

  useEffect(() => {
    if (Course_Single_Data) {
      if (EditFormOpener) {
        dispatch(CAMPUS_LISTS(Course_Single_Data[0].University_Id));
      }
    }
  }, [Course_Single_Data, dispatch, EditFormOpener]);

  // -----
  /*  Course Edit Req Error and Success handle End  */

  return (
    <>
      <div
        id="CreatContact"
        className={
          FormOpener || EditFormOpener ? "overlay-note w100 " : "overlay-note"
        }
      >
        <div className="Alert">
          {" "}
          {Alert.length > 0
            ? Alert.map((el, i) => (
                <AlertBox
                  key={i}
                  alert={el}
                  validator={
                    Course_Create_Success || Course_Update_Success
                      ? true
                      : false
                  }
                />
              ))
            : ""}
        </div>
        <div className="overlay-add-deals contact-right-side">
          <div className="note-title">
            <h4 className="text-left text-white pl-3">
              {EditFormOpener ? "Update Course" : "Create Course"}
            </h4>
            <button
              href="#"
              className="closebtn text-right text-white"
              disabled={
                Campus_Added_Loading ||
                Course_Update_Loading ||
                Campus_DeleteAll_Loading
              }
              onClick={() => {
                EditFormOpener ? handleEditCancel() : handleFormCancel();
              }}
            >
              &times;
            </button>
          </div>
          {!EditFormOpener ? (
            <div className="contact-body modify-create-contact">
              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label>
                    Course Name:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Course Name"
                    name="Course_Name"
                    value={CourseForm.Course_Name}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"University Name"}:<b>*</b>
                  </label>
                  <UniversitySelector
                    CourseForm={CourseForm}
                    handleFormChange={handleFormChange}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Campus Name"}:<b>*</b>
                  </label>
                  <MultiSelector
                    multiselectRefTracker={multiselectRefTracker}
                    setCampusDropDown={setCampusDropDown}
                    setSelectCampus={setSelectCampus}
                    handleMultiSelectRemove={handleMultiSelectRemove}
                    setPreSeSelectedCampuses={setPreSeSelectedCampuses}
                    PreSeSelectedCampuses={PreSeSelectedCampuses}
                    Campus_list_By_Course={Campus_list_By_Course}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Course Url"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Course Url"
                    name={"Course_Url"}
                    value={CourseForm.Course_Url}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Intake"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Intake"
                    name={"Intakes"}
                    value={CourseForm.Intakes}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Duration"}:<b>*</b>
                  </label>
                  <input
                    className="form-control"
                    placeholder="Enter Duration"
                    name={"Duration"}
                    value={CourseForm.Duration}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Duration Filter"}:<b>*</b>
                  </label>
                  <select
                    className="form-control"
                    placeholder="Enter Duration"
                    name={"duration_int"}
                    value={CourseForm.duration_int}
                    onChange={(e) => handleFormChange(e)}
                  >
                    <option value="">select Duration</option>
                    <option value="1">Upto 1 Year</option>
                    <option value="2">1-2 Year</option>
                    <option value="3">2-3 Year</option>
                    <option value="4">3-4 Year</option>
                    <option value="5">4+ Year</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>
                    {" Yearly Tuition Fees"}:<b>*</b>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter  Yearly Tuition Fees"
                    name={"Yearly_Tuition_Fees"}
                    value={CourseForm.Yearly_Tuition_Fees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"IELTS Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter IELTS Required"
                    name={"IELTS_Required"}
                    value={CourseForm.IELTS_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"PTE Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PTE Required"
                    name={"PTE_Required"}
                    value={CourseForm.PTE_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"TOEFL Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="TOEFL Required"
                    name={"TOEFL_Required"}
                    value={CourseForm.TOEFL_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {" GRE Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter GRE Required"
                    name={"GRE_Required"}
                    value={CourseForm.GRE_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"GMAT_Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter GMAT Required"
                    name={"GMAT_Required"}
                    value={CourseForm.GMAT_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Duolingo Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Duolingo Required"
                    name={"Duolingo_Required"}
                    value={CourseForm.Duolingo_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                {/*//Entry_Requirement classNameic Editor */}
                <div className="sed_classNameic_editor">
                  <label>
                    Entry Requirement:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Entry Requirement"}
                      value={
                        EditFormOpener
                          ? CourseForm.Entry_Requirement
                          : CourseclassNameicEditorInput.Entry_Requirement
                      }
                      onChange={(e) =>
                        EditFormOpener
                          ? setCourseForm({
                              ...CourseForm,
                              Entry_Requirement: e,
                            })
                          : setCourseclassNameicEditorInput({
                              Entry_Requirement: e,
                            })
                      }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    {"Application Fees"}:<b>*</b>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Application Fees"
                    name={"Application_Fees"}
                    value={CourseForm.Application_Fees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Application Deadline"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Application Deadline"
                    name={"Application_Deadline"}
                    value={CourseForm.Application_Deadline}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"IELTS Score"}:<b>*</b>
                  </label>
                  <IeltsScore
                    CourseForm={CourseForm}
                    handleFormChange={handleFormChange}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Course Type"}:<b>*</b>
                  </label>
                  <CourseTypeSelector
                    CourseForm={CourseForm}
                    handleFormChange={handleFormChange}
                  />
                </div>
                {/* meta  */}

                 <div className="form-group">
                  <label>
                    {"Meta Title"}:
                  </label>
                   <input
                    type="text"
                    className="form-control"
                    placeholder="Meta Title"
                    name={"Meta_Title"}
                    value={CourseForm.Meta_Title}
                    onChange={(e) => handleFormChange(e)}
                  />
                  
                </div>
                <div className="form-group">
                  <label>
                    {"Meta Description"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="Meta Description"
                    name={"Meta_Description"}
                    value={CourseForm.Meta_Description}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"OG_Image url"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="OG Image"
                    name={"OG_Image"}
                    value={CourseForm.OG_Image}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Canonical Url"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="Canonical Url"
                    name={"Canonical_Url"}
                    value={CourseForm.Canonical_Url}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="contact-footer w-100">
                  <button
                    type="submit"
                    disabled={Campus_Added_Loading || Course_Create_Loading}
                    className="btn"
                  >
                    {Campus_Added_Loading || Course_Create_Loading
                      ? "Loading..."
                      : "Create Course"}
                  </button>
                  <button
                    type="button"
                    disabled={Campus_Added_Loading || Campus_DeleteAll_Loading}
                    className="btn btn-deep-orange waves-effect waves-light"
                    onClick={() => {
                      EditFormOpener ? handleEditCancel() : handleFormCancel();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="contact-body modify-create-contact">
              <form onSubmit={handleEditFormSubmit}>
                <div className="form-group">
                  <label>
                    Course Name:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Course Name"
                    name="Course_Name"
                    value={CourseForm2.Course_Name}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"University Name"}:<b>*</b>
                  </label>
                  <UniversitySelector
                    UniversityId={CourseForm2.University_Id}
                    handleFormChange={handleFormChange}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Campus Name"}:<b>*</b>
                  </label>
                  <MultiSelector
                    multiselectRefTracker={multiselectRefTracker}
                    setCampusDropDown={setCampusDropDown}
                    setSelectCampus={setSelectCampus}
                    handleMultiSelectRemove={handleMultiSelectRemove}
                    setPreSeSelectedCampuses={setPreSeSelectedCampuses}
                    PreSeSelectedCampuses={PreSeSelectedCampuses}
                    Campus_list_By_Course={Campus_list_By_Course}
                  />
                  {/* <Multiselect
                    options={Campus_Lists}
                    placeholder="Select Campuses"
                    displayValue="Campus_Name"
                    onSelect={(e) => {
                      setCampusDropDown(true);
                      setSelectCampus(e);
                    }}
                    ref={multiselectRefTracker}
                    onRemove={(e) => {
                      setCampusDropDown(true);
                      handleMultiSelectRemove(e);
                    }}
                    showCheckbox={true}
                    selectedValues={PreSeSelectedCampuses}
                  />*/}
                </div>
                <div className="form-group">
                  <label>
                    {"Course Url"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Course Url"
                    name={"Course_Url"}
                    value={CourseForm2.Course_Url}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Intake"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Intake"
                    name={"Intakes"}
                    value={CourseForm2.Intakes}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Duration"}:<b>*</b>
                  </label>
                  <input
                    className="form-control"
                    placeholder="Enter Duration"
                    name={"Duration"}
                    value={CourseForm2.Duration}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Duration Filter"}:<b>*</b>
                  </label>
                  <select
                    className="form-control"
                    placeholder="Enter Duration"
                    name={"duration_int"}
                    value={CourseForm2.duration_int}
                    onChange={(e) => handleFormChange(e)}
                  >
                    <option value="">select Duration</option>
                    <option value="1">Upto 1 Year</option>
                    <option value="2">1-2 Year</option>
                    <option value="3">2-3 Year</option>
                    <option value="4">3-4 Year</option>
                    <option value="5">4+ Year</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>
                    {" Yearly Tuition Fees"}:<b>*</b>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter  Yearly Tuition Fees"
                    name={"Yearly_Tuition_Fees"}
                    value={CourseForm2.Yearly_Tuition_Fees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"IELTS Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter IELTS Required"
                    name={"IELTS_Required"}
                    value={CourseForm2.IELTS_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"PTE Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PTE Required"
                    name={"PTE_Required"}
                    value={CourseForm2.PTE_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"TOEFL Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="TOEFL Required"
                    name={"TOEFL_Required"}
                    value={CourseForm2.TOEFL_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {" GRE Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter GRE Required"
                    name={"GRE_Required"}
                    value={CourseForm2.GRE_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"GMAT_Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter GMAT Required"
                    name={"GMAT_Required"}
                    value={CourseForm2.GMAT_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Duolingo Required"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Duolingo Required"
                    name={"Duolingo_Required"}
                    value={CourseForm2.Duolingo_Required}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                {/*//Entry_Requirement classNameic Editor */}
                <div className="sed_classNameic_editor">
                  <label>
                    Entry Requirement:<span>*</span>
                  </label>
                  <div>
                    <ReactQuill
                      placeholder={"Entry Requirement"}
                      value={CourseclassNameicEditorInput2.Entry_Requirement}
                      onChange={(e) =>
                        setCourseclassNameicEditorInput2({
                          Entry_Requirement: e,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    {"Application Fees"}:<b>*</b>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Application Fees"
                    name={"Application_Fees"}
                    value={CourseForm2.Application_Fees}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Application Deadline"}:<b>*</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Application Deadline"
                    name={"Application_Deadline"}
                    value={CourseForm2.Application_Deadline}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"IELTS Score"}:<b>*</b>
                  </label>
                  <IeltsScore
                    CourseForm={CourseForm2}
                    handleFormChange={handleFormChange}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"Course Type"}:<b>*</b>
                  </label>
                  <CourseTypeSelector
                    CourseForm={CourseForm2}
                    handleFormChange={handleFormChange}
                  />
                </div>

                 <div className="form-group">
                  <label>
                    {"Meta Title"}:
                  </label>
                   <input
                    type="text"
                    className="form-control"
                    placeholder="Meta Title"
                    name={"Meta_Title"}
                    value={CourseForm2.Meta_Title}
                    onChange={(e) => handleFormChange(e)}
                  />
                  
                </div>
                <div className="form-group">
                  <label>
                    {"Meta Description"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="Meta Description"
                    name={"Meta_Description"}
                    value={CourseForm2.Meta_Description}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {"OG_Image url"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="OG Image"
                    name={"OG_Image"}
                    value={CourseForm2.OG_Image}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {"Canonical Url"}:
                  </label>
                 <input
                    type="text"
                    className="form-control"
                    placeholder="Canonical Url"
                    name={"Canonical_Url"}
                    value={CourseForm2.Canonical_Url}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>


                <div className="contact-footer w-100">
                  {EditFormOpener ? (
                    <button
                      type="submit"
                      disabled={
                        Campus_Added_Loading ||
                        Course_Update_Loading ||
                        Campus_DeleteAll_Loading
                      }
                      className="btn"
                    >
                      {Campus_Added_Loading ||
                      Course_Update_Loading ||
                      Campus_DeleteAll_Loading
                        ? "Loading.."
                        : "Update Course"}
                    </button>
                  ) : (
                    <button
                      type="submit"
                      disabled={Campus_Added_Loading || Course_Update_Loading}
                      className="btn"
                    >
                      {Course_Create_Loading ? "Loading..." : "Create Course"}
                    </button>
                  )}

                  <button
                    type="button"
                    disabled={Course_Update_Loading || Campus_DeleteAll_Loading}
                    className="btn btn-deep-orange waves-effect waves-light"
                    onClick={() => handleEditCancel()}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
